import { Component, Inject, ViewChildren, QueryList } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RunnerData, System, Type } from '@app/shared/components/argument-card/runner-details-dialog/runner-details';
import { Labels } from '@app/util/labels.util';
import { TourGuideContent } from '@app/util/tour-guide-content.util'
import { MatSelect } from '@angular/material/select';
import { TourGuideService } from '@app/services/tour-guide.service';
import { Subscription } from 'rxjs';
import { ConfigBuilderService } from '@app/services/config-builder.service';
import dummyData from '@app/assets/api-dummy-data.json';

@Component({
  selector: 'app-runner-dialog',
  templateUrl: './runner-details-dialog.component.html',
  styleUrls: ['./runner-details-dialog.component.scss']
})

export class RunnerDetailsDialogComponent {

  /****************** Variable declaration ******************/
  types = Object.keys(Type).filter(prio => isNaN(Number(prio)))
  systems = Object.keys(System).filter(prio => isNaN(Number(prio)))
  labels: any = []
  data: any = ''
  typeLabel = Labels.typeLabel;
  osLabel = Labels.osLabel;
  labelLabel = Labels.labelLabel;
  tourGuideIds = TourGuideContent;
  dataSubscription: Subscription

  detailsForm = new FormGroup({
    type: new FormControl('', Validators.required),
    os: new FormControl('', Validators.required),
    label: new FormControl('', Validators.required)
  })

  /****************** View child ******************/
  @ViewChildren(MatSelect) matSelects: QueryList<MatSelect>;

  /**
   * Constructor
   * @param runnerData 
   * @param dialogRef 
   * @param guideService 
   * @param configBuid 
   * @returns 
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public runnerData: RunnerData | any,
    private dialogRef: MatDialogRef<RunnerDetailsDialogComponent>,
    private guideService: TourGuideService,
    private configBuid: ConfigBuilderService
  ) {
    this.dataSubscription = this.guideService.data$.subscribe((res: any) => {
      this.matSelects.forEach(matSelect => {
        if (res?.operation === 'open') {
          matSelect.open();
        } else if (res?.operation === 'close') {
          matSelect.close();
        }
      });
    });

    /** tour guide */
    if (this.guideService.isStartTour) {
      this.labels = dummyData.configBuilder.workflow.labels;
      this.data = new RunnerData(this.runnerData?.data);
      return;
    }

    if (this.runnerData?.data) {
      this.data = new RunnerData(this.runnerData?.data);
      this.selectDropDown()
    } else {
      this.data = new RunnerData();
    }
  }

  get type() {
    return this.detailsForm.get('type')
  }

  get os() {
    return this.detailsForm.get('os')
  }

  get label() {
    return this.detailsForm.get('label')
  }

  onSuccess() {
    this.dialogRef.close(this.data);
  }

  selectDropDown() {
    if (this.data.type && this.data.os) {
      this.detailsForm.get('label')?.reset();
      this.getLabelsApi(this.data.os, this.data.type)
    }
  }

  getLabelsApi(os: string, type: string) {
    this.labels = []
    this.configBuid.getRunnerLabels(os, type).subscribe((res: any) => {
      this.labels = res
    })
  }
}
